<template>
  <div>
    <div class="filter-form">
      <el-form class="elementui-common-form-styles" ref="form" inline label-width="40px">
        <el-form-item>
          <ElInput v-model="filterForm.keyword" placeholder="请输入计划名称" clearable @keyup.enter.native="queryAction">
            <i slot="append" @click="queryAction" class="el-icon-search"></i>
          </ElInput>
        </el-form-item>

        <el-form-item label="事件类型" label-width="80px">
          <el-select v-model="filterForm.callType" @change="queryAction" clearable placeholder="请选择事件类型">
            <el-option v-for="item in callTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="filterForm.sendType" @change="queryAction" clearable placeholder="请选择">
            <el-option v-for="item in logStatus" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账号">
          <el-select
            v-model="filterForm.adAccountId"
            style="width: 200px"
            multiple
            collapse-tags
            filterable
            @change="queryAction"
            clearable
            placeholder="请选择"
          >
            <el-option v-for="item in MEDIA_ACCOUNTS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="媒体">
          <el-select
            v-model="filterForm.mediaId"
            style="width: 180px"
            multiple
            collapse-tags
            filterable
            @change="queryAction"
            clearable
            placeholder="请选择"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <DateRangePicker v-model="filterForm.logTime" @change="queryAction" style="width: 240px"></DateRangePicker>
        </el-form-item>

        <el-form-item class="bg-transparent">
          <el-button @click="onTableExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <Viewport v-model="reportLogGridOptions.height" v-loading="tableLoading">
      <vxe-grid ref="xGrid" v-bind="reportLogGridOptions"> </vxe-grid>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.page.pageId"
          :page-size.sync="pager.page.pageSize"
          :total="pager.total"
          :page-sizes="[10, 20, 30, 40, 50]"
          @current-change="getPageData"
          @size-change="queryAction"
          layout="sizes, prev, pager, next, total"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from '@/components/date-range-picker'
import DataReports from './data/data-reports.class.js'
import { getReportLogByPage } from '@/api/report.model'
import { HOST_API } from '@/api/config'

import { initPageData, MEDIA_ACCOUNTS, MEDIAS } from '@/data/global-opts'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([MEDIA_ACCOUNTS, MEDIAS])

export default {
  name: 'data-report-log',
  components: { DateRangePicker },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      filterForm: {
        keyword: '',
        sendType: '',
        adAccountId: [],
        mediaId: [],
        logTime: []
      },
      reportLogGridOptions: DataReports.getGridLogOptions(),
      callTypeList: DataReports.CALL_TYPE_LIST,
      logStatus: DataReports.LOG_STATES_LIST,
      pager: {
        page: {
          pageId: 1,
          pageSize: 20
        },
        total: 0
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  activated() {
    this.getPageData()
  },
  created() {
    const start = moment().subtract(30, 'days').format('YYYY-MM-DD')
    const end = moment().format('YYYY-MM-DD')
    this.filterForm.logTime = [start, end]
  },
  methods: {
    queryAction() {
      this.pager.page.pageId = 1
      this.getPageData()
    },
    buildParams() {
      const { ruleId } = this.$route.query
      const { keyword, logTime, callType, sendType, mediaId, adAccountId } = this.filterForm
      const [beginTime, endTime] = logTime || []
      const params = {}
      if (ruleId) params.ruleId = ruleId
      if (keyword) params.keyword = keyword
      if (callType) params.callType = callType
      if (sendType) params.sendType = sendType
      if (mediaId?.length) params.mediaIdStr = mediaId.join(',')
      if (adAccountId?.length) params.adAccountIdStr = adAccountId.join(',')
      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      return params
    },
    getPageData() {
      if (this.tableLoading) return
      const params = this.buildParams()
      this.tableLoading = true
      getReportLogByPage({ ...params, ...this.pager.page })
        .then((data) => {
          const { list, page_info } = data
          this.reportLogGridOptions.data = list || []
          this.pager.total = page_info.total_number
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    onTableExport() {
      const params = new URLSearchParams(this.buildParams()).toString()
      let url = `${HOST_API}/api/ptom/callback/filterlog/down`
      if (params) {
        url += `?${params}`
      }
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pager {
  text-align: right;
}
</style>
